import { Injectable, Injector } from '@angular/core';

/**
 * Common utils service
 */
@Injectable({
	providedIn: 'root',
	deps: [Injector],
})
export class CommonUtilsService {
	/**
	 * Gets module name
	 *
	 * @param name name
	 * @returns module name
	 */
	getModuleName(name: string): string {
		return name;
	}
}
